export const BENEFFICIARY_UNIT = [
  {
    label: 'individual_label',
    value: 'i'
  },
  {
    label: 'household_label',
    value: 'h'
  }
]

export const CASH_OR_KIND = [
  {
    label: 'cash_label',
    value: 'c'
  },
  {
    label: 'kind_label',
    value: 'k'
  }
]


export const EXIST_BENEFIT = [
  {
    label: 'yes_label',
    value: true
  },
  {
    label: 'no_label',
    value: false
  }
]

export const PERMANENT_OR_TEMPORAL = [
  {
    label: 'permanent_label',
    value: 'p'
  },
  {
    label: 'temporal_label',
    value: 't'
  }
]

export const FINANCING_SOURCE = [
  {
    label: 'taxes_label',
    value: 'taxes'
  },
  {
    label: 'contributions_label',
    value: 'contributions'
  },
  {
    label: 'external_label',
    value: 'external'
  },
  {
    label: 'mixt_label',
    value: 'mixt'
  }
]
